import {Component, computed, inject, signal, ChangeDetectionStrategy} from "@angular/core"
import {MatButtonModule} from "@angular/material/button"
import {MatCheckboxModule} from "@angular/material/checkbox"
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from "@angular/material/dialog"

export interface BatchOperationDialogData {
    configurationCount: number
    unassignedCount: number
    title: string
    description: string
    confirmLabel: string
    includeUnassignedByDefault?: boolean
    destructive?: boolean
}

export interface BatchOperationDialogResult {
    includeUnassigned: boolean
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-batch-operation-dialog",
    templateUrl: "./batch-operation-dialog.component.html",
    styleUrls: ["./batch-operation-dialog.component.scss"],
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule, MatCheckboxModule],
})
export class BatchOperationDialogComponent {
    readonly dialogRef = inject(MatDialogRef<BatchOperationDialogComponent>)
    readonly data = inject<BatchOperationDialogData>(MAT_DIALOG_DATA)

    readonly $includeUnassigned = signal(this.data.includeUnassignedByDefault ?? true)

    readonly $totalCount = computed(() => {
        return this.data.configurationCount + (this.$includeUnassigned() ? this.data.unassignedCount : 0)
    })

    cancelAction(): void {
        this.dialogRef.close(undefined)
    }

    confirmAction(): void {
        this.dialogRef.close({includeUnassigned: this.$includeUnassigned()})
    }
}
